import { Component } from '@angular/core';
import { CustomButtons } from '@class/commons/custom-buttons';

@Component({
  selector: 'app-retry-button',
  templateUrl: './retry-button.component.html',
  styleUrls: ['./retry-button.component.scss'],
})
export class RetryButtonComponent extends CustomButtons {}
